import { Typography } from '@mui/material';

interface HeaderCellProps {
  title: string;
  subTitle: string;
}

export const HeaderCell = ({ title, subTitle }: HeaderCellProps) => {
  return (
    <>
      <Typography component="div" variant="subtitle2" noWrap>
        {title}
      </Typography>
      <Typography
        component="div"
        variant="caption"
        noWrap
        sx={{
          color: 'text.secondary',
        }}
      >
        {subTitle}
      </Typography>
    </>
  );
};
